import React from "react";

export const FARM_MAP_HELP_TITLE = "Mapa da fazenda";

export function FarmMapHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Esta tela é{" "}
        <strong>compartilhada com o app do operador</strong> no smartphone. O
        que você configurar e publicar aqui aparece automaticamente no{" "}
        <strong>mapa da fazenda do app de campo</strong>.
      </p>

      <p>
        <strong>Rumos A-B para pilotos automáticos:</strong>
      </p>
      <ul>
        <li>
          marque os pontos <strong>A</strong> e <strong>B</strong> no mapa
          satélite, com latitude, longitude e rumo;
        </li>
        <li>
          salve e publique — a referência fica disponível para o operador no
          celular, junto com as demais camadas do mapa.
        </li>
      </ul>

      <p>
        <strong>Ferramentas de desenho no mapa:</strong>
      </p>
      <ul>
        <li>
          <strong>Desenhar fazenda</strong> — trace o contorno externo (somente
          linha). Talhões dentro do perímetro são vinculados automaticamente à
          fazenda;
        </li>
        <li>
          <strong>Medir área</strong> e <strong>Desenhar talhões</strong> —
          após concluir o polígono, use <strong>Adicionar recorte interno</strong>{" "}
          para subtrair áreas internas (ex.: matas, estradas) da área líquida.
        </li>
      </ul>

      <p>
        <strong>Talhões:</strong>
      </p>
      <ul>
        <li>
          <strong>desenhe talhões</strong> no mapa ou{" "}
          <strong>importe um arquivo KML</strong>;
        </li>
        <li>
          ao salvar, a <strong>área em hectares entra no nome</strong> do
          talhão — por exemplo, se você digitar apenas <strong>T</strong>, o
          nome salvo fica <strong>T — 45 ha</strong> (hectares arredondados
          para o inteiro mais próximo — ex.: 25,6 ha vira <strong>26 ha</strong>,
          24,99 ha vira <strong>25 ha</strong>);
        </li>
        <li>
          se o nome ficar em branco, o talhão usa somente a área, ex.:{" "}
          <strong>45 ha</strong>.
        </li>
      </ul>

      <p>
        <strong>Soma de hectares (seleção múltipla):</strong>
      </p>
      <ul>
        <li>
          na <strong>lista à esquerda</strong>, clique no <strong>nome de um
          talhão</strong> e depois em outros — a plataforma{" "}
          <strong>soma automaticamente os hectares</strong> selecionados e
          exibe o total no topo da lista;
        </li>
        <li>
          no <strong>mapa satélite</strong>, clique <strong>diretamente sobre
          um talhão</strong> para selecioná-lo; se clicar em <strong>dois ou
          mais talhões</strong>, as áreas também são <strong>somadas</strong> —
          o mesmo total aparece na lista à esquerda.
        </li>
      </ul>

      <p>
        <strong>Sincronização com o app de campo:</strong>
      </p>
      <ul>
        <li>
          desenhar ou editar talhões, linhas e rumos A-B <strong>salva na
          plataforma web</strong>, mas <strong>não envia sozinho</strong> para
          o tablet;
        </li>
        <li>
          quando terminar as alterações, clique em{" "}
          <strong>Sincronizar com app de campo</strong> — isso publica uma nova
          revisão para os tablets;
        </li>
        <li>
          o app do operador verifica essa revisão a cada 30 segundos e{" "}
          <strong>só então</strong> baixa o mapa; se a rede falhar, ele{" "}
          <strong>mantém o último mapa salvo</strong> no tablet.
        </li>
      </ul>
    </>
  );
}

export const FARM_MAP_SYNC_HELP_TITLE = "Sincronização com o app de campo";

export function FarmMapSyncHelpContent() {
  return (
    <>
      <p>
        Os dados criados nesta página do <strong>mapa da fazenda</strong> só são
        sincronizados com o <strong>app de campo</strong> após clicar em{" "}
        <strong>Sincronizar com app de campo</strong>.
      </p>
      <p>
        Depois de implementar qualquer alteração nesta área da plataforma, é
        necessário sincronizar:
      </p>
      <ul>
        <li>talhões desenhados ou editados;</li>
        <li>linhas;</li>
        <li>rumos A-B.</li>
      </ul>
      <p>
        <strong>Sem essa sincronização, as mudanças não aparecem no app de
        campo.</strong>
      </p>
    </>
  );
}
